import { CoreToolMessage, ToolContent } from "ai";
import { z } from "zod";
import { toolResultPartSchema } from "./core-message-part";

export const coreToolMessageContent = z.array(
  toolResultPartSchema,
) satisfies z.ZodType<ToolContent>;

export const coreToolMessageSchema = z.object({
  role: z.literal("tool"),
  content: coreToolMessageContent,
}) satisfies z.ZodType<CoreToolMessage>;

export const redoCoreToolMessageSchema = coreToolMessageSchema.and(
  z.object({ id: z.string() }),
);

export type RedoCoreToolMessageType = z.infer<typeof redoCoreToolMessageSchema>;
